module.exports = __webpack_public_path__ + "static/media/empresa.57a8beb6.svg";